import { FC, useState, useEffect, useMemo } from 'react'
import {
  ISectionTestSyncTranslate,
  ISessionAnswer,
  ISessionAnswerProgress,
  ISyncTranslate
} from 'shared/types'
import { VStack } from '@chakra-ui/react'
import TestTask from 'shared/components/sections/tests/TestTask'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import size from 'lodash/size'
import filter from 'lodash/filter'
import forEach from 'lodash/forEach'
import reduce from 'lodash/reduce'
import { getTestTitle } from 'shared/utils/tests'
import TestCard from 'shared/components/sections/tests/TestCard'
import SyncTranslateParagraph from 'shared/components/sections/sectionTestSyncTranslate/SyncTranslateParagraph'

type Props = {
  s: ISectionTestSyncTranslate
  onAnswer?: (sectionId: string, answer: ISessionAnswer) => void
  answer?: ISessionAnswer
  testNum?: number
  showUserAnswer?: boolean
  isExamination: boolean
}

const SectionTestSyncTranslate: FC<Props> = ({
  s,
  onAnswer,
  answer: answerRaw,
  testNum,
  showUserAnswer,
  isExamination
}) => {
  const [paragraphsRes, setParagraphsRes] = useState([])

  useEffect(() => {
    if (s.test) {
      const initialParagrapsRes: ISessionAnswerProgress[] = []
      forEach(s.test?.syncTranslate, (p) => {
        const sap: ISessionAnswerProgress = {
          correctAmount: 0,
          answersAmount: 0,
          fullAmount: size(p.matching),
          completed: size(p.matching) === 0
        }
        initialParagrapsRes.push(sap)
      })
      setParagraphsRes(initialParagrapsRes)
    }
  }, [s.test])

  console.log('paragraphsRes', paragraphsRes)

  const answer =
    answerRaw && get(answerRaw.progress, 'completed', false)
      ? answerRaw
      : undefined

  const onParagraphComplete = (
    i: number,
    paragraphProgress: ISessionAnswerProgress
  ) => {
    // console.log('onParagraphComplete', i, isCorrect)
    const newParagraphs: ISessionAnswerProgress[] = [...paragraphsRes]
    newParagraphs[i] = { ...paragraphProgress } as ISessionAnswerProgress
    setParagraphsRes(newParagraphs)

    const completed =
      size(newParagraphs.filter((v) => v.completed)) === size(newParagraphs)
    const fullAmount = reduce(newParagraphs, (res, p) => res + p.fullAmount, 0)
    const answersAmount = reduce(
      newParagraphs,
      (res, p) => res + p.answersAmount,
      0
    )
    const correctAmount = reduce(
      newParagraphs,
      (res, p) => res + p.correctAmount,
      0
    )
    const correct = newParagraphs.filter((v) => v != null && v)
    console.log({ newParagraphs, completed })
    // if (completed.length === newParagraphs.length) {
    const sa: ISessionAnswer = {
      answer: '',
      isCorrect: correct.length === newParagraphs.length,
      progress: {
        correctAmount,
        answersAmount,
        fullAmount,
        completed
      }
    }
    if (onAnswer) {
      onAnswer(s.id, sa)
    }
  }

  const renderParagraph = (st: ISyncTranslate, i: number) => {
    return (
      <SyncTranslateParagraph
        key={i}
        st={st}
        isExamination={isExamination}
        showUserAnswer={showUserAnswer}
        completed={!isNil(answer)}
        highlightCorrectAnswer={get(s.test, 'highlightCorrectAnswer', false)}
        onComplete={(paragraphProgress: ISessionAnswerProgress) =>
          onParagraphComplete(i, paragraphProgress)
        }
      />
    )
  }

  return (
    <TestCard showUserAnswer={showUserAnswer} answer={answer}>
      <TestTask
        title={s.test?.title || getTestTitle(s.type)}
        answer={showUserAnswer ? undefined : answer}
        testNum={testNum}
      />
      <VStack w='full' spacing={{ base: 4, lg: 6 }}>
        {map(s.test?.syncTranslate, renderParagraph)}
      </VStack>
    </TestCard>
  )
}

export default SectionTestSyncTranslate
